import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { transaksiMasukTable as transaksiMasukTableAkuntan } from "./transaksiMasukTable";
import { transaksiMasukDetailTable as transaksiMasukDetailTableAkuntan } from "./transaksiMasukDetailTable";

// API
import {
  deleteTransaksiMasuk as deleteTransaksiMasukAkuntan,
  getDataTransMasuk as getDataTransMasukAkuntan,
  insertNewTransaksiMasuk as insertNewTransaksiMasukAkuntan,
} from "./api/transaksiMasukAPI";

// Component
import CardTableNoAdd from "components/Cards/CardTableNoAdd";
import ConfirmModal from "components/Modal/ConfirmModal";
import FormCustom from "components/Forms/FormCustom";

import toast, { Toaster } from "react-hot-toast";
import { transaksiMasukFormData as transaksiMasukFormDataAkuntan } from "./transaksiMasukFormData";

export default function TransaksiMasukAkuntan() {
  const history = useHistory();

  const [dataTable, setDataTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  // const [formData, setFormData] = useState(null);

  // const [formDataArr, setFormDataArr] = useState([]);

  // Type Search
  const [typeSearch, setTypeSearch] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  // State for Table Detail Transaksi Masuk
  const [showDetailTransaksi, setShowDetailTransaksi] = useState(false);
  const [detailTransaksi, setDetailTransaksi] = useState(false);

  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [deletePopUp, setDeletePopUp] = useState([{ show: false, id: null }]);

  // State For Input New Transaksi Masuk
  const [addForm, setAddForm] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataArr, setFormDataArr] = useState([]);

  // Component is Active?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // Load Data Table
  useEffect(() => {
    if (active === true) {
      setIsLoading(true);
      getDataTransMasukAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
    }

    return () => {
      // setFormData(null);
    };
  }, [active]);

  // Clear Form Data When First Time Load Component
  // useEffect(() => {
  //   setFormData(null);
  // })

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getDataTransMasukAkuntan(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getDataTransMasukAkuntan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Handle When User want to see detail Transaksi Masuk
  const handleGetDetail = (rowData) => {
    // Lihat Detail Transaksi
    setShowDetailTransaksi(true);

    // Tambahkan Data Detail Transaksi
    setDetailTransaksi(rowData.detail_transaksi_masuk);
  };

  // Handle When User Click Cancel Button in Detail Transaksi Masuk
  const handleCancelButton = () => {
    setShowDetailTransaksi(false);
    setAddForm(false);
  };

  // Handle when User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_transaksi_masuk,
    });
  };

  // Handle When User Confirm to Delete Data
  const handleDeleteTrue = () => {
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deleteTransaksiMasukAkuntan(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle When User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle End Submit Process
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setFormData(null);
    setIsLoading(false);
  };

  // Check If Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  });

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setActive(true);
        history.push("transaction/transaksiMasuk");
        setShowDetailTransaksi(true);
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }
    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, []);

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(transaksiMasukFormDataAkuntan());

    return () => {
      setFormDataArr([]);
    };
  }, []);

  // Handle when User Click Add Button
  function handleInsert(rowData) {
    setActive(false);
    setFormData({ id_anggaran_pemasukan: rowData.id_anggaran_pemasukan });
    setAddForm(true);
  }

  // Handle when User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewTransaksiMasukAkuntan(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={null}
              // getData = {getData}
            />
          </div>
        </div>
      </div>
    );

  if (showDetailTransaksi === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            {deletePopUp.show && (
              <div>
                <ConfirmModal
                  handleIfTrue={(e) => handleDeleteTrue()}
                  handleIfFalse={(e) => handleDeleteFalse()}
                />
              </div>
            )}
            <Toaster />
            <CardTableNoAdd
              tableTitle="Tabel Detail Transaksi Penerimaan"
              cols={transaksiMasukDetailTableAkuntan(handleDelete)}
              data={detailTransaksi}
              handleCancelButton={handleCancelButton}
              pageNumber={pageNumber}
              changePage={changePage}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {/* {deletePopUp.show && <div><ConfirmModal handleIfTrue={(e) => handleDeleteTrue()} handleIfFalse={(e) => handleDeleteFalse()} /></div>} */}
          <Toaster />
          <CardTableNoAdd
            tableTitle="Tabel Transaksi Penerimaan"
            cols={transaksiMasukTableAkuntan(handleGetDetail, handleInsert)}
            data={dataTable}
            handleSearch={handleSearch}
            pageNumber={pageNumber}
            changePage={changePage}
          />
        </div>
      </div>
    </div>
  );
}
